<section
  class="verification-method-container be-section-mb-sm"
  [formGroup]="beFormGroup"
  >
  <h3
    id="verificationLabel"
    class="be-text-md font-medium be-section-mb--responsive"
    >
    To provide you with the best protection, choose a 2-Step Verification method
    to verify your identity.
  </h3>
  <mat-radio-group
    color="primary"
    aria-labelledby="verificationLabel"
    class="verification-radio-group"
    [formControlName]="beFormControlName"
    >
    @for (contactMethod of contactMethodList; track contactMethod) {
      <mat-radio-button
        class="verification-radio"
        [value]="contactMethod"
        >
        @if (contactMethod.type === 'email') {
          <div class="verification-radio__header">
            <svg class="verification-radio__icon" viewBox="0 0 100 100">
              <use href="assets/icons-v2/sprites.svg#mail"></use>
            </svg>
            <h3 class="heading-s-bold verification-radio__title">Email</h3>
          </div>
          <p class="be-text-md verification-radio__text">
            Send code to
            <span
              class="be-text-md verification-radio__text verification-radio__text--bold"
              >{{ contactMethod.value }}</span
              >
            </p>
          }
          @if (contactMethod.type === 'phone') {
            <div class="verification-radio__header">
              <svg class="verification-radio__icon" viewBox="0 0 100 100">
                <use href="assets/icons-v2/sprites.svg#message-square"></use>
              </svg>
              <h3 class="heading-s-bold verification-radio__title">
                SMS (rates apply)
              </h3>
            </div>
            <p class="be-text-md verification-radio__text">
              Send code to
              <span
                class="be-text-md verification-radio__text verification-radio__text--bold"
                >{{ contactMethod.value | mask : '000-000-0000' }}</span
                >
              </p>
            }
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (beFormControl.hasError('required') && beFormControl.touched) {
        <div
          class="contact-method-error"
          >
          <app-be-helper-text helperId="contactMethodError" helperType="error">
            Please choose a verification method
          </app-be-helper-text>
        </div>
      }
    </section>
